import { render } from "./ReservationRequestList.vue?vue&type=template&id=4b22c942&ts=true"
import script from "./ReservationRequestList.vue?vue&type=script&lang=ts"
export * from "./ReservationRequestList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__